import { AppThunk } from 'redux/store';
import { IRequestBase, VerificationDocumentTypes } from 'types';
import { IAppSettings, IUserInfo, IVerifyBankAccount } from 'redux/reducers/user/type';
import { IPhoneInputForm } from 'components/PhoneInputForm';

export enum TypesUser {
  CREATE_USER_REQUEST = 'user.CREATE_USER_REQUEST',
  CREATE_USER_SUCCESS = 'user.CREATE_USER_SUCCESS',
  CREATE_USER_ERROR = 'user.CREATE_USER_ERROR',

  REFRESH_TOKEN_USER_REQUEST = 'user.REFRESH_TOKEN_USER_REQUEST',
  REFRESH_TOKEN_USER_SUCCESS = 'user.REFRESH_TOKEN_USER_SUCCESS',
  REFRESH_TOKEN_USER_ERROR = 'user.REFRESH_TOKEN_USER_ERROR',

  GET_USER_INFO_REQUEST = 'user.GET_USER_INFO_REQUEST',
  GET_USER_INFO_SUCCESS = 'user.GET_USER_INFO_SUCCESS',
  GET_USER_INFO_ERROR = 'user.GET_USER_INFO_ERROR',

  GET_PREFERABLE_LANGUAGES_REQUEST = 'user.GET_PREFERABLE_LANGUAGES_REQUEST',
  GET_PREFERABLE_LANGUAGES_SUCCESS = 'user.GET_PREFERABLE_LANGUAGES_SUCCESS',
  GET_PREFERABLE_LANGUAGES_ERROR = 'user.GET_PREFERABLE_LANGUAGES_ERROR',

  PATCH_USER_REQUEST = 'user.PATCH_USER_REQUEST',
  PATCH_USER_SUCCESS = 'user.PATCH_USER_SUCCESS',
  PATCH_USER_ERROR = 'user.PATCH_USER_ERROR',

  SEND_OTP_USER_REQUEST = 'user.SEND_OTP_USER_REQUEST',
  SEND_OTP_USER_SUCCESS = 'user.SEND_OTP_USER_SUCCESS',
  SEND_OTP_USER_ERROR = 'user.SEND_OTP_USER_ERROR',

  LOGIN_OTP_USER_REQUEST = 'user.LOGIN_OTP_USER_REQUEST',
  LOGIN_OTP_USER_SUCCESS = 'user.LOGIN_OTP_USER_SUCCESS',
  LOGIN_OTP_USER_ERROR = 'user.LOGIN_OTP_USER_ERROR',

  GET_USER_PAYMENTS_REQUEST = 'user.GET_USER_PAYMENTS_REQUEST',
  GET_USER_PAYMENTS_SUCCESS = 'user.GET_USER_PAYMENTS_SUCCESS',
  GET_USER_PAYMENTS_ERROR = 'user.GET_USER_PAYMENTS_ERROR',

  CLEAR_LOGIN_SESSION = 'user.CLEAR_LOGIN_SESSION',
  CLEAR_USER = 'user.CLEAR_USER',

  LOGOUT = 'user.LOGOUT',

  POST_VERIFY_DOCUMENT_REQUEST = 'user.POST_VERIFY_DOCUMENT_REQUEST',
  POST_VERIFY_DOCUMENT_SUCCESS = 'user.POST_VERIFY_DOCUMENT_SUCCESS',
  POST_VERIFY_DOCUMENT_ERROR = 'user.POST_VERIFY_DOCUMENT_ERROR',

  GET_VERIFY_DOCUMENT_REQUEST = 'user.GET_VERIFY_DOCUMENT_REQUEST',
  GET_VERIFY_DOCUMENT_SUCCESS = 'user.GET_VERIFY_DOCUMENT_SUCCESS',
  GET_VERIFY_DOCUMENT_ERROR = 'user.GET_VERIFY_DOCUMENT_ERROR',

  GET_AADHAAR_CARD_DETAILS_REQUEST = 'user.GET_AADHAAR_CARD_DETAILS_REQUEST',
  GET_AADHAAR_CARD_DETAILS_SUCCESS = 'user.GET_AADHAAR_CARD_DETAILS_SUCCESS',
  GET_AADHAAR_CARD_DETAILS_ERROR = 'user.GET_AADHAAR_CARD_DETAILS_ERROR',

  SEND_AADHAAR_CARD_NUMBER_REQUEST = 'user.SEND_AADHAAR_CARD_NUMBER_REQUEST',
  SEND_AADHAAR_CARD_NUMBER_SUCCESS = 'user.SEND_AADHAAR_CARD_NUMBER_SUCCESS',
  SEND_AADHAAR_CARD_NUMBER_ERROR = 'user.SEND_AADHAAR_CARD_NUMBER_ERROR',

  SEND_AADHAR_OTP_USER_REQUEST = 'user.SEND_AADHAR_OTP_USER_REQUEST',
  SEND_AADHAR_OTP_USER_SUCCESS = 'user.SEND_AADHAR_OTP_USER_SUCCESS',
  SEND_AADHAR_OTP_USER_ERROR = 'user.SEND_AADHAR_OTP_USER_ERROR',

  STATUS_OF_LOAN_SUCCESS = 'user.STATUS_OF_LOAN_SUCCESS',

  POST_VERIFY_BANK_ACCOUNT_REQUEST = 'user.REQUEST_ANOTHER',
  POST_VERIFY_BANK_ACCOUNT_SUCCESS = 'user.POST_VERIFY_BANK_ACCOUNT_SUCCESS',
  POST_VERIFY_BANK_ACCOUNT_ERROR = 'user.POST_VERIFY_BANK_ACCOUNT_ERROR',

  GET_VERIFY_BANK_ACCOUNT_REQUEST = 'user.GET_VERIFY_BANK_ACCOUNT_REQUEST',
  GET_VERIFY_BANK_ACCOUNT_SUCCESS = 'user.GET_VERIFY_BANK_ACCOUNT_SUCCESS',
  GET_VERIFY_BANK_ACCOUNT_ERROR = 'user.GET_VERIFY_BANK_ACCOUNT_ERROR',

  GET_IFCS_REQUEST = 'user.REQUEST',
  GET_IFCS_SUCCESS = 'user.GET_IFCS_SUCCESS',
  GET_IFCS_ERROR = 'user.GET_IFCS_ERROR',
  CLEAR_VERIFY_IFCS = 'user.CLEAR_VERIFY_IFCS',

  GET_EXPERIAN_INFO_REQUEST = 'user.GET_EXPERIAN_INFO_REQUEST',
  GET_EXPERIAN_INFO_SUCCESS = 'user.GET_EXPERIAN_INFO_SUCCESS',
  GET_EXPERIAN_INFO_ERROR = 'user.GET_EXPERIAN_INFO_ERROR',

  GET_KYC_DETAILS_REQUEST = 'user.GET_KYC_DETAILS_REQUEST',
  GET_KYC_DETAILS_SUCCESS = 'user.GET_KYC_DETAILS_SUCCESS',
  GET_KYC_DETAILS_ERROR = 'user.GET_KYC_DETAILS_ERROR',

  POST_BANK_STATEMENT_ANALYSIS_REQUEST = 'user.POST_BANK_STATEMENT_ANALYSIS_REQUEST',
  POST_BANK_STATEMENT_ANALYSIS_SUCCESS = 'user.POST_BANK_STATEMENT_ANALYSIS_SUCCESS',
  POST_BANK_STATEMENT_ANALYSIS_ERROR = 'user.POST_BANK_STATEMENT_ANALYSIS_ERROR',

  PUT_SETU_DATA_ANALYSIS_REQUEST = 'user.PUT_SETU_DATA_ANALYSIS_REQUEST',
  PUT_SETU_DATA_ANALYSIS_SUCCESS = 'user.PUT_SETU_DATA_ANALYSIS_SUCCESS',
  PUT_SETU_DATA_ANALYSIS_ERROR = 'user.PUT_SETU_DATA_ANALYSIS_ERROR',

  POST_EXPERIAN_INFO_REQUEST = 'user.POST_EXPERIAN_INFO_REQUEST',
  POST_EXPERIAN_INFO_SUCCESS = 'user.POST_EXPERIAN_INFO_SUCCESS',
  POST_EXPERIAN_INFO_ERROR = 'user.POST_EXPERIAN_INFO_ERROR',

  POST_OZ_FORENSICS_REQUEST = 'user.POST_OZ_FORENSICS_REQUEST',
  POST_OZ_FORENSICS_SUCCESS = 'user.POST_OZ_FORENSICS_SUCCESS',
  POST_OZ_FORENSICS_ERROR = 'user.POST_OZ_FORENSICS_ERROR',

  POST_OZ_LIVENESS_RESULT_REQUEST = 'user.POST_OZ_LIVENESS_RESULT_REQUEST',
  POST_OZ_LIVENESS_RESULT_SUCCESS = 'user.POST_OZ_LIVENESS_RESULT_SUCCESS',
  POST_OZ_LIVENESS_RESULT_ERROR = 'user.POST_OZ_LIVENESS_RESULT_ERROR',

  SEND_CONFIRM_CODE_EXPERIAN_REQUEST = 'user.SEND_CONFIRM_CODE_EXPERIAN_REQUEST',
  SEND_CONFIRM_CODE_EXPERIAN_SUCCESS = 'user.SEND_CONFIRM_CODE_EXPERIAN_SUCCESS',
  SEND_CONFIRM_CODE_EXPERIAN_ERROR = 'user.SEND_CONFIRM_CODE_EXPERIAN_ERROR',

  POST_CONFIRM_CODE_EXPERIAN_REQUEST = 'user.POST_CONFIRM_CODE_EXPERIAN_REQUEST',
  POST_CONFIRM_CODE_EXPERIAN_SUCCESS = 'user.POST_CONFIRM_CODE_EXPERIAN_SUCCESS',
  POST_CONFIRM_CODE_EXPERIAN_ERROR = 'user.POST_CONFIRM_CODE_EXPERIAN_ERROR',

  POST_UPLOAD_PANCARD_FRONT_REQUEST = 'user.POST_UPLOAD_PANCARD_FRONT_REQUEST',
  POST_UPLOAD_PANCARD_FRONT_SUCCESS = 'user.POST_UPLOAD_PANCARD_FRONT_SUCCESS',
  POST_UPLOAD_PANCARD_FRONT_ERROR = 'user.POST_UPLOAD_PANCARD_FRONT_ERROR',

  POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_REQUEST = 'user.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_REQUEST',
  POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_SUCCESS = 'user.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_SUCCESS',
  POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_ERROR = 'user.POST_UPLOAD_SELFIE_AND_PANCARD_FRONT_ERROR',

  POST_CONSENT_GIVEN_REQUEST = 'user.POST_CONSENT_GIVEN_REQUEST',
  POST_CONSENT_GIVEN_SUCCESS = 'user.POST_CONSENT_GIVEN_SUCCESS',
  POST_CONSENT_GIVEN_ERROR = 'user.POST_CONSENT_GIVEN_ERROR',

  GET_APP_SETTINGS_REQUEST = 'user.GET_APP_SETTINGS_REQUEST',
  GET_APP_SETTINGS_SUCCESS = 'user.GET_APP_SETTINGS_SUCCESS',
  GET_APP_SETTINGS_ERROR = 'user.GET_APP_SETTINGS_ERROR',

  SEND_X_DRY_RUN_REQUEST = 'user.SEND_X_DRY_RUN_REQUEST',
  SEND_X_DRY_RUN_SUCCESS = 'user.SEND_X_DRY_RUN_SUCCESS',
  SEND_X_DRY_RUN_ERROR = 'user.SEND_X_DRY_RUN_ERROR',

  SAVE_RETRY_AFTER = 'SAVE_RETRY_AFTER',
  REMOVE_RETRY_AFTER = 'REMOVE_RETRY_AFTER',

  SET_AADHAAR_VERIFICATION_INFO = 'user.SET_AADHAR_UI_STATUS',
}

export interface ISetAuthDataStorage {
  id: string;
  token: string;
  refresh_token: string;
}

export interface IUserVerifySetAuthDataStorage {
  is_data_processing_consent_given: boolean;
  token: {
    token: string;
    refresh_token: string;
    user: {
      id: string;
    };
  };
}

export interface IPatchUserData extends IRequestBase {
  values: Partial<IUserInfo>;
}

export type PatchUserType = (data: IPatchUserData) => AppThunk<void>;

export interface CreateUserData extends IRequestBase {
  values: IPhoneInputForm;
}

export type CreateUser = (data: CreateUserData) => AppThunk<void>;

export interface SendOTPUserData extends IRequestBase {
  values: {
    username: string;
  };
}

export type SendOTPUser = (data: SendOTPUserData) => AppThunk<void>;

export interface UserVerifyOtpTypeData extends IRequestBase {
  values: {
    phone_number: string;
    is_data_processing_consent_given?: boolean;
    is_credit_bureau_consent_given?: boolean;
  };
  headers?: {
    'X-Dry-Run': string;
  };
}

export type UserVerifyOtpType = (data: UserVerifyOtpTypeData) => AppThunk<void>;

export type PostConfirmationCodeApplicationType = (
  data: {
    confirmation_code: string;
  } & IRequestBase
) => AppThunk<void>;

export type GetExperianType = (data: { isLoading?: boolean } & IRequestBase) => AppThunk<void>;

export type GetKycDetailsType = (data: { isLoading?: boolean } & IRequestBase) => AppThunk<void>;

export type PostConfirmationCodeExperianType = (
  data: {
    otp: string;
    isMasked: boolean;
    mobileNumber?: string;
  } & IRequestBase
) => AppThunk<void>;

export type SendConfirmationCodeExperianType = (
  data?: {
    maskedMobile?: string;
  } & IRequestBase
) => AppThunk<void>;

export type VerifyDocumentType = (
  data: {
    document_number: string;
    document_type: VerificationDocumentTypes;
  } & IRequestBase
) => AppThunk<void>;

export type GetVerifyDocumentType = (
  data: { KYCRequestId: number; type: VerificationDocumentTypes } & IRequestBase
) => AppThunk<void>;

export type GetAadhaarCardDetailsType = (
  data: { aadhaar_number: string; isPending?: boolean } & IRequestBase
) => AppThunk<void>;

export type SendAadhaarNumberType = (
  data: { aadhaar_number: string } & IRequestBase
) => AppThunk<void>;

export type PostVerifyBankAccountType = (
  data: { ifsc_code: string; account_number: string; isLoading?: boolean } & IRequestBase
) => AppThunk<void>;

export type GetVerifyBankAccountType = (
  data: { isLoading?: boolean; verifyBankAccount?: IVerifyBankAccount } & IRequestBase
) => AppThunk<void>;

export type GetVerifyIFCSType = (
  data: { isLoading?: boolean; ifsc_code: string } & IRequestBase
) => AppThunk<void>;

export type SendAadhaarOtpType = (data: { otp: string } & IRequestBase) => AppThunk<void>;

export type UploadPanCardType = (file: File) => AppThunk<void>;

export type OzLivenessResultType = (
  data: { initialization_result?: string; videoinput_exist?: string } & IRequestBase
) => AppThunk<void>;

export interface AppSettingsData extends IRequestBase {
  data: IAppSettings;
}

export type AppSettings = (data: AppSettingsData) => AppThunk<void>;

export interface ISetuDataAnalysis extends IRequestBase {
  skipped_by_client?: boolean;
  skipped_by_timer?: boolean;
  client_redirected_to_setu?: boolean;
  client_redirected_from_setu?: boolean;
  skipped_in_modal?: boolean;
}

export type SetuDataAnalysisType = (data: ISetuDataAnalysis) => AppThunk<void>;
